import { compose } from 'recompose';
import { withNamespaces } from 'react-i18next';
import TasksSummary from './tasksSummary';

const enhance = compose(
  withNamespaces(['tasks']),
);
export default enhance(TasksSummary);
